/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 商品マスタアラート
 * @export
 * @interface AlertMstItem
 */
export interface AlertMstItem {
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstItem
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    alertTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    itemName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    mstItemItemName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    supplierName: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstItem
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    salesStartdate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    salesEnddate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    replaceItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    replaceOrgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    janCase: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    recencyFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    masterNotFound: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    minRecDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    isInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    unmatchRenewal: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstItem
     */
    isAlert: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstItem
     */
    alertMessage: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    trStartDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    minArrivalDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    lastArrivalDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstItem
     */
    lastShipDate: Date | null;
}

/**
 * Check if a given object implements the AlertMstItem interface.
 */
export function instanceOfAlertMstItem(value: object): value is AlertMstItem {
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('alertTypeName' in value) || value['alertTypeName'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('itemName' in value) || value['itemName'] === undefined) return false;
    if (!('mstItemItemName' in value) || value['mstItemItemName'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('salesStartdate' in value) || value['salesStartdate'] === undefined) return false;
    if (!('salesEnddate' in value) || value['salesEnddate'] === undefined) return false;
    if (!('replaceItemCode' in value) || value['replaceItemCode'] === undefined) return false;
    if (!('replaceOrgItemCode' in value) || value['replaceOrgItemCode'] === undefined) return false;
    if (!('janCase' in value) || value['janCase'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('recencyFlg' in value) || value['recencyFlg'] === undefined) return false;
    if (!('masterNotFound' in value) || value['masterNotFound'] === undefined) return false;
    if (!('minRecDate' in value) || value['minRecDate'] === undefined) return false;
    if (!('isInactive' in value) || value['isInactive'] === undefined) return false;
    if (!('unmatchRenewal' in value) || value['unmatchRenewal'] === undefined) return false;
    if (!('isAlert' in value) || value['isAlert'] === undefined) return false;
    if (!('alertMessage' in value) || value['alertMessage'] === undefined) return false;
    if (!('trStartDate' in value) || value['trStartDate'] === undefined) return false;
    if (!('minArrivalDate' in value) || value['minArrivalDate'] === undefined) return false;
    if (!('lastArrivalDate' in value) || value['lastArrivalDate'] === undefined) return false;
    if (!('lastShipDate' in value) || value['lastShipDate'] === undefined) return false;
    return true;
}

export function AlertMstItemFromJSON(json: any): AlertMstItem {
    return AlertMstItemFromJSONTyped(json, false);
}

export function AlertMstItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertMstItem {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'companyId': json['company_id'],
        'alertTypeName': json['alert_type_name'],
        'orgItemCode': json['org_item_code'],
        'itemCode': json['item_code'],
        'itemName': json['item_name'],
        'mstItemItemName': json['mst_item_item_name'],
        'orgSupplierId': json['org_supplier_id'],
        'supplierName': json['supplier_name'],
        'supplierCompanyId': json['supplier_company_id'],
        'salesStartdate': (json['sales_startdate'] == null ? null : new Date(json['sales_startdate'])),
        'salesEnddate': (json['sales_enddate'] == null ? null : new Date(json['sales_enddate'])),
        'replaceItemCode': json['replace_item_code'],
        'replaceOrgItemCode': json['replace_org_item_code'],
        'janCase': json['jan_case'],
        'remarks': json['remarks'],
        'recencyFlg': json['recency_flg'],
        'masterNotFound': json['master_not_found'],
        'minRecDate': (json['min_rec_date'] == null ? null : new Date(json['min_rec_date'])),
        'isInactive': json['is_inactive'],
        'unmatchRenewal': json['unmatch_renewal'],
        'isAlert': json['is_alert'],
        'alertMessage': json['alert_message'],
        'trStartDate': (json['tr_start_date'] == null ? null : new Date(json['tr_start_date'])),
        'minArrivalDate': (json['min_arrival_date'] == null ? null : new Date(json['min_arrival_date'])),
        'lastArrivalDate': (json['last_arrival_date'] == null ? null : new Date(json['last_arrival_date'])),
        'lastShipDate': (json['last_ship_date'] == null ? null : new Date(json['last_ship_date'])),
    };
}

export function AlertMstItemToJSON(json: any): AlertMstItem {
    return AlertMstItemToJSONTyped(json, false);
}

export function AlertMstItemToJSONTyped(value?: AlertMstItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'alert_type_name': value['alertTypeName'],
        'org_item_code': value['orgItemCode'],
        'item_code': value['itemCode'],
        'item_name': value['itemName'],
        'mst_item_item_name': value['mstItemItemName'],
        'org_supplier_id': value['orgSupplierId'],
        'supplier_name': value['supplierName'],
        'supplier_company_id': value['supplierCompanyId'],
        'sales_startdate': value['salesStartdate'] == null ? value['salesStartdate'] : value['salesStartdate'].toISOString(),
        'sales_enddate': value['salesEnddate'] == null ? value['salesEnddate'] : value['salesEnddate'].toISOString(),
        'replace_item_code': value['replaceItemCode'],
        'replace_org_item_code': value['replaceOrgItemCode'],
        'jan_case': value['janCase'],
        'remarks': value['remarks'],
        'recency_flg': value['recencyFlg'],
        'master_not_found': value['masterNotFound'],
        'min_rec_date': value['minRecDate'] == null ? value['minRecDate'] : value['minRecDate'].toISOString(),
        'is_inactive': value['isInactive'],
        'unmatch_renewal': value['unmatchRenewal'],
        'is_alert': value['isAlert'],
        'alert_message': value['alertMessage'],
        'tr_start_date': value['trStartDate'] == null ? value['trStartDate'] : value['trStartDate'].toISOString(),
        'min_arrival_date': value['minArrivalDate'] == null ? value['minArrivalDate'] : value['minArrivalDate'].toISOString(),
        'last_arrival_date': value['lastArrivalDate'] == null ? value['lastArrivalDate'] : value['lastArrivalDate'].toISOString(),
        'last_ship_date': value['lastShipDate'] == null ? value['lastShipDate'] : value['lastShipDate'].toISOString(),
    };
}

